import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useGetCurrentUser } from "@/hooks/useUser";

/**
 * Mantém o usuário anexado ao Sentry sincronizado com o usuário autenticado
 * (dado explicitamente, nunca via `sendDefaultPii`). Um único efeito cobre
 * login, cadastro, restauração de sessão no boot e logout, porque todos eles
 * passam por `useGetCurrentUser`.
 */
export const useSentryUser = () => {
  const { data: user } = useGetCurrentUser();

  useEffect(() => {
    if (user) {
      Sentry.setUser({ id: user.id, email: user.email, username: user.username });
    } else {
      Sentry.setUser(null);
    }
  }, [user]);
};
